import { ReactComponent as ArrowDown } from './arrowDown.svg';

export default ArrowDown;
